import { Component, OnInit } from '@angular/core';
// import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FaqsService } from '../../../../blocks/faqs/services/faqs.service';
import { NgbAccordionConfig } from '@ng-bootstrap/ng-bootstrap';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'dc-politica-cookies-contenido',
  templateUrl: './politica-cookies-contenido.component.html',
  styleUrls: ['./politica-cookies-contenido.component.scss']
})
export class PoliticaCookiesContenidoComponent implements OnInit {
  chevronDown = faChevronDown;
  chevronUp = faChevronUp;
  faqs = [];

  constructor(config: NgbAccordionConfig, private faqService: FaqsService) {
    config.closeOthers = true;
  }

  ngOnInit(): void {
    this.faqService.getFaqsCookies().subscribe(faqs => (this.faqs = faqs));
  }

  desplegarRespuesta(index) {
    if (this.faqs[index].estado == false) {
      this.faqs[index].estado = true;
      // this.chevron = faChevronUp;
    } else {
      this.faqs[index].estado = false;
    }
  }
}
